import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Lock, CircleDot } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    const cleanPin = pin.trim();
    if (!cleanPin) return;
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { pin: cleanPin });
      localStorage.setItem("app_pin", data.token);
      toast.success("Accesso effettuato");
      navigate("/");
    } catch (err) {
      const status = err?.response?.status;
      if (!status || status >= 500) {
        toast.error("Server preview non raggiungibile. Riprova tra poco.");
      } else if (status === 401) {
        toast.error("PIN non valido");
      } else {
        toast.error("Errore durante il login");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 tread-bg" data-testid="login-page">
      <div className="diag-stripes h-2 w-full absolute top-0 left-0" />
      <form onSubmit={submit} className="border-2 border-black bg-white brutal-shadow-lg p-8 w-full max-w-md space-y-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-black flex items-center justify-center border-2 border-black">
            <CircleDot className="w-6 h-6 text-[#E60000]" strokeWidth={3} />
          </div>
          <div>
            <div className="font-display font-black text-2xl uppercase tracking-tighter leading-none">
              Gomme<span className="text-[#E60000]">.</span>Track
            </div>
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] mt-1">
              Area Riservata Operatori
            </div>
          </div>
        </div>

        <div className="diag-stripes h-1 w-full" />

        <div>
          <label className="block text-xs font-black uppercase tracking-widest mb-2">
            Codice PIN
          </label>
          <div className="flex items-center border-2 border-black bg-white">
            <Lock className="w-5 h-5 ml-3" strokeWidth={3} />
            <input
              data-testid="pin-input"
              type="password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              placeholder="Inserisci PIN"
              autoFocus
              className="flex-1 p-3 outline-none font-mono-data font-black text-lg tracking-widest bg-transparent"
            />
          </div>
        </div>

        <button
          type="submit"
          data-testid="pin-submit"
          disabled={loading || !pin}
          className="w-full bg-[#E60000] text-white border-2 border-black px-6 py-3 font-bold uppercase tracking-widest hover:bg-black transition-colors disabled:opacity-50"
        >
          {loading ? "Accesso..." : "Entra"}
        </button>

        <div className="text-[10px] font-bold uppercase tracking-[0.2em] opacity-60 text-center">
          Sistema interno • Solo personale autorizzato
        </div>
      </form>
    </div>
  );
}
